// Modules
import React from 'react';

// Utils
import { formatPhone } from './utils/phoneValidation';

const ContactPracticeMessage = (props) => {
  const { name, phone } = props;

  return (
    <p>
      Please contact {name} at{' '}
      <a href={`tel:+1${phone}`}>{formatPhone(phone)}</a> to pay your
      outstanding balance.
    </p>
  );
};

export default ContactPracticeMessage;
